import { read, utils } from 'xlsx';
import { removeEmptyRows } from '~/lib/xlsx/xlsxStandardFileToRows';
export const sortNumbers = (a: number, b: number) => {
  return a - b;
};
export const sortStrings = (a: string | undefined, b: string | undefined) => {
  if (typeof a !== 'string') return -1;
  if (typeof b !== 'string') return -1;
  return a.localeCompare(b);
};

export type CellValueImported = string | number;
export type XlsxFileRow = [];
export type TableRows<
  COLS extends string = string,
  D extends CellValueImported = CellValueImported,
> = Record<COLS, D>;
export type StdTableData = TableRows;
export const xlsxFileToRows = async (
  file: File,
  cb: (rows: XlsxFileRow[]) => void,
) => {
  const reader = new FileReader();
  reader.readAsArrayBuffer(file);
  reader.onload = (event) => {
    if (!event.target) return;
    const wb = read(event.target.result);
    const sheets = wb.SheetNames;
    console.log(sheets);
    if (sheets.length && sheets.includes('Portfolio Master')) {
      const sheetObj = wb.Sheets['Portfolio Master'];
      const range = utils.decode_range(sheetObj['!ref'] ?? '');
      range.s.r = 2;
      range.s.c = 2;
      sheetObj['!ref'] = utils.encode_range(range);
      // console.log("range",range);
      const rows = removeEmptyRows(
        utils.sheet_to_json(sheetObj, { header: 1 }),
      ) as XlsxFileRow[];
      console.log('rows[0]', rows[0]);
      console.log('rows[1]', rows[1]);
      cb(rows);
    }
    reader.onerror = () => {
      console.log(reader.error);
    };
  };
};

export const rows2TableData = (rows: (string | number)[][]): StdTableData[] => {
  const columns = rows[0] as XlsxFileRow;
  const processRows = rows.slice(1);
  return processRows.map((row, idx) => {
    const obj: Record<string, string | number> = {};
    columns.forEach((value: CellValueImported, index: number) => {
      obj[value] = row[index] ?? '';
    });
    const idProp = { id: idx };
    return { ...obj, ...idProp };
  });
};
